var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.719 20.833c1.6428-2.0538 2.6252-4.659 2.6252-7.4937 0-6.6304-5.375-12.005-12.005-12.005-6.6305 0-12.005 5.375-12.005 12.005 0 6.6304 5.375 12.006 12.005 12.006 2.8346 0 5.4398-0.9824 7.4938-2.6254l7.5568 7.557c0.521 0.521 1.3656 0.521 1.8866 0 0.521-0.5208 0.521-1.3656 0-1.8864l-7.557-7.557zm-9.3802 1.8572c-5.1644 0-9.351-4.1865-9.351-9.3509s4.1866-9.351 9.351-9.351c5.1644 0 9.351 4.1866 9.351 9.351s-4.1866 9.3509-9.351 9.3509z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.42dcd23cac2e0cc856ac7ef451b88652.svg";
export { ForwardRef as ReactComponent };